'use strict';

(function (angular) {
  angular.module('zp').controller('ShopController', shopController);

  /**@ngInject */
  function shopController($window, $state, $timeout, ShopService, LoaderService) {
    var vm = this;

    vm.items = [];

    vm.openItem = openItem;
    var width = $window.innerWidth > 1200 ? "360px" : $window.innerWidth > 700 ? "320px" : "260px";

    /**Activate */
    (function () {
      // LoaderService.start();
      loadItems().then(function () {
        // $timeout(LoaderService.stop, 1000);
      });
    })();

    function loadItems() {
      return ShopService.getAll().then(function (response) {
        for (var i = 0; i < response.length; i++) {
          response[i].style.width = width;
        }
        vm.items = response;
      });
    }

    function openItem(item) {
      $state.go('nav.shop-item', { name: item.name });
    }
  }
})(window.angular);